import React, {Fragment } from 'react';

export const APP_TITLE = "Total Compensation Estimator";

export const YOUR_ELIGIBLE_PAY = <Fragment><span className="reqast"></span>Your <a href="../../../benefits/retirement/uc-retirement-choice-program/#definitions" target="_blank">eligible pay (Opens in a new window)</a>(ex: 36835.00)</Fragment>;

export const PRIMARY_RETIREMENT_BENEFITS = <Fragment><span className="reqast"></span>Please select your <a href="../../../benefits/retirement/uc-retirement-choice-program/" target="_blank">primary retirement benefit option (Opens in a new window)</a> </Fragment>;

export const POSITION_TYPE = <Fragment><span className="reqast"></span>Is your position <a href="../compensation-and-benefitsretirement-benefits/2016-retirement-choice/definitions.html#designated-faculty" target="_blank">designated faculty (Opens in a new window)</a> or staff/other academic appointee?</Fragment>;

export const MEDICAL_PLAN = "In which medical plan are you enrolled?";

export const MEDICAL_PLAN_COVER = "Who does your medical plan cover?";

export const DENTAL_PLAN = "In which dental plan are you enrolled?";

export const DENTAL_PLAN_COVER ="Who does your dental plan cover?";

export const HIRE_DATE_TIER = "When were you hired for your current position?";

export const REHIRED_OR_INELIGIBLE = "Are you a rehired former UCRP member or an employee previously ineligible for retirement benefits who has obtained an eligible appointment?"

export const HIRE_BEFORE_DATE = "Were you originally hired before 7/1/16?";

export const EMPLOYEE_COSTS_ASTERISK = "* Voluntary employee plans, such as Supplemental Health Plans, Legal Insurance, Supplemental Life and Voluntary Disability, are not included.";
